module.exports = __webpack_public_path__ + "img/13.baf9aa91.png";